import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSessionReset } from '@renderer/stores/sessionState'

interface QuitModalProps {
  showModal: boolean
  setShowModal: (show: boolean) => void
}

const QuitModal: React.FC<QuitModalProps> = ({ showModal, setShowModal }) => {
  const resetSession = useSessionReset()
  const { t } = useTranslation()

  if (!showModal) return null

  const confirmReset = async (): Promise<void> => {
    await resetSession()
    setShowModal(false)
  }

  const cancelReset = (): void => {
    setShowModal(false)
  }

  return (
    <div className="absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[10]">
      <div className="bg-uriYellow text-center rounded-3xl w-[1000px] overflow-hidden">
        <p className="text-black font-semibold text-[90px] font-serif-bahela mx-[70px] my-[120px]">
          {t('controls.cancelConfirm')}
        </p>
        <div className="flex justify-between gap-0">
          <button
            type="button"
            className="bg-prominentBlue text-white text-[90px] font-body-bahela w-1/2 py-2"
            onClick={confirmReset}
          >
            {t('common.yes')}
          </button>
          <button
            type="button"
            className="bg-methadone text-white text-[90px] font-body-bahela w-1/2 py-2"
            onClick={cancelReset}
          >
            {t('common.no')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default QuitModal
